import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-dark-surface text-white py-20 px-4 md:px-8" data-id="element-50">
      <div className="max-w-4xl mx-auto" data-id="element-51">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-52">
          {/* Guarantee seal */}
          <div className="flex-shrink-0" data-id="element-53">
            <div className="relative w-48 h-48 md:w-56 md:h-56" data-id="element-54">
              {/* Outer circle */}
              <div className="absolute inset-0 rounded-full border-4 border-brand-orange bg-dark-bg flex items-center justify-center shadow-[0_0_30px_rgba(255,107,53,0.3)]" data-id="element-55">
                {/* Inner content */}
                <div className="text-center" data-id="element-56">
                  <ShieldCheck className="w-16 h-16 md:w-20 md:h-20 text-brand-orange mx-auto mb-2" data-id="element-57" />
                  <div className="font-oswald text-5xl md:text-6xl font-bold text-white leading-none" data-id="element-58">
                    7
                  </div>
                  <div className="font-oswald text-xl md:text-2xl font-bold text-brand-orange uppercase" data-id="element-59">
                    DÍAS
                  </div>
                </div>
              </div>
              {/* Rotating border effect */}
              <div className="absolute inset-0 rounded-full border-2 border-dashed border-brand-orange/40 animate-spin" style={{
              animationDuration: '20s'
            }} data-id="element-60"></div>
            </div>
          </div>

          {/* Copy */}
          <div className="flex-1 text-center md:text-left" data-id="element-61">
            <h2 className="font-oswald text-3xl md:text-4xl font-bold mb-6 uppercase" data-id="element-62">
              Garantía total de{' '}
              <span className="text-brand-orange" data-id="element-63">7 días</span>
            </h2>
            <div className="font-inter text-lg md:text-xl text-gray-300 space-y-4 leading-relaxed" data-id="element-64">
              <p data-id="element-65">
                Si en 7 días sentís que esto no era para vos, te devolvemos cada
                centavo. Sin preguntas. Sin formularios complicados. Sin drama.
              </p>
              <p className="text-white font-semibold" data-id="element-66">
                El riesgo es cero. La única decisión es si arrancás hoy o seguís
                esperando el lunes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}